import React from 'react';
import PropTypes from 'prop-types';

import '../global-sass/main.scss';

const Options = ({ options }) => {
	const accessories = options.map((item) => {
		return (
			<li className="mb-4 text-muted" key={item.id}>
				{item.text}
			</li>
		);
	});
	return <ul className="list-unstyled">{accessories}</ul>;
};

Options.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired
		})
	).isRequired
};

export default Options;
